module.exports = __webpack_public_path__ + "static/media/5.2eb9202d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/九宫格未选中态/5.png
// module id = 945
// module chunks = 0